
export const defaultTextFieldStyle = {
    backgroundColor: 'white',
    borderRadius: 2, // 2 = 16px (default theme spacing unit * 0.5)
    '& .MuiOutlinedInput-root': {
        borderRadius: 2,
    }
}

export const filterTextFieldStyle = {
    backgroundColor: 'white',
    borderRadius: 2, // 2 = 16px (default theme spacing unit * 0.5)
    '& .MuiOutlinedInput-root': {
        borderRadius: 2,
    },
    marginBottom: 2
}

export const disabledTextFieldStyle = {
    borderRadius: 2, // 2 = 16px (default theme spacing unit * 0.5)
    '& .MuiOutlinedInput-root': {
        borderRadius: 2,
    }
}